export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value || 0);
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const calculateAge = (birthDate) => {
  if (!birthDate) return "";
  const birth = new Date(birthDate);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  if (age < 0) return "";
  return `${age} anos`;
};

/**
 * Formata data no padrão brasileiro dd/MM/yyyy
 * @param {string|Date} dateString - Data em formato ISO ou objeto Date
 * @returns {string} Data formatada ou string vazia
 */
export const formatDate = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    // Check if date is valid
    if (isNaN(date.getTime())) return "";
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error("Error formatting date:", error);
    return "";
  }
};

/**
 * Formata data e hora no padrão brasileiro dd/MM/yyyy às HH:mm
 * @param {string|Date} dateString - Data em formato ISO ou objeto Date
 * @param {string} time - Hora no formato HH:mm
 * @returns {string} Data e hora formatadas
 */
export const formatDateTime = (dateString, time) => {
  const formattedDate = formatDate(dateString);
  if (!formattedDate) return "";
  if (!time) return formattedDate;
  return `${formattedDate} às ${time}`;
};
